<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'app-table-header-item'
}
</script>
